import {kYoutubeVideoLink} from "../../../constants/links";

export default function HomeMissionVideo() {
    // Used in HomeMission to display Ummia project video

    // BUILD
    return (
        <div className="flex w-[520px] md:min-w-[400px] aspect-video">
            <iframe
                className="w-full h-full rounded-[16px]"
                src={kYoutubeVideoLink}
                title="Projet Ummia"
                allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                allowFullScreen />
        </div>
    );
}